/**
 * Created by Z179603 on 7/13/2016.
 */

'use strict';

angular.module('cvsApp')
    .service('webAnalyticsData', function () {

        function webAnalyticsData() {

            var webAnalyticsData = {
                "accountBalance": {
                    page_name: 'account balance',
                    page_category: 'my account',
                    scenario_name: 'reg:OLP',
                    scenario_step: 'balance'
                },
                "makePayment": {
                    page_name: 'make a payment',
                    page_category: 'my account',
                    scenario_name: 'reg:OLP',
                    scenario_step: 'payment type' //paymentType should be dynamic
                },
                "paymentMethod":{
                    page_name: 'select payment method',
                    page_category: 'my account',
                    scenario_name: 'reg:OLP',
                    scenario_step: '1-time pay method' //MOP should be dynamic
                },
                "autoPay": {
                    page_name: 'srx: set up autopay',
                    page_category: 'payments',
                    adobe_page_name: 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + 'srx: set up autopay',
                },
                "addBank":{
                    page_name: 'srx: add bank account',
                    page_category: 'payments',
                    adobe_page_name: 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + 'srx: add bank account',
                },
                "editBank":{
                    page_name: 'add/edit bank account',
                    page_category: 'My Account',
                    scenario_name: 'reg:OLP',
                    scenario_step: 'Bank Account Details'

                },
                "addCreditCard":{
                    page_name: 'srx: add credit card',
                    page_category: 'payments',
                    adobe_page_name: 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + 'srx: add credit card',
                },
                "editCreditCard":{
                    page_name: 'srx: edit credit card',
                    page_category: 'payments',
                    adobe_page_name: 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + 'srx: edit credit card',
                    scenario_name: 'reg:OLP',
                    scenario_step: 'CC Details',
                    page_error : undefined
                },
                "reviewOnetimePayment": {
                    page_name: 'srx: review payment',
                    adobe_page_name: 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + 'srx:review payment',
                    page_category: 'payments'
                },
                "reviewAutoPayments": {
                    page_name: 'srx: review auto payment',
                    adobe_page_name: 'cvssp' + '|' + cvsUtility.getPlatform() + '|' + 'srx:review payment',
                    page_category: 'payments'
                },
                "paymentConfirmation": {
                    page_name: 'srx: payment confirmation',
                    page_category: 'My Account',
                    scenario_name: 'reg:OLP',
                    scenario_step: '1-time pay success / recurring pay success' //dynamic (1-time pay success or recurring pay success)
                },
                "paymentConfirmationRefill": {
                    page_name: 'Link: Pay Success: Refill Now',
                    page_category: 'Refill'
                },
                "confirmIdentificationMakePayment": {
                    page_name: 'link: confirm ID: make payment only',
                    page_category: 'Payments'
                },
                "guestAccountBalance": {
                    page_name: 'account balance',
                    page_category: 'Payment',
                    scenario_name: 'unreg: OLP',
                    scenario_step: 'Balance',
                    tsrc:cvsUtility.queryMap.source // dynamic value email/sms for guest user and do't populate if register user
                },
                "guestMakePayment": {
                    page_name: 'make a payment',
                    page_category: 'Payment',
                    scenario_name: 'unreg: OLP',
                    scenario_step: 'Make Payment',
                    tsrc:cvsUtility.queryMap.source // dynamic value email/sms for guest user and do't populate if register user
                },
                "guestPaymentMethod": {
                    page_name: 'select payment method',
                    page_category: 'payment',
                    scenario_name: 'unreg: OLP',
                    scenario_step: 'Pay Method',
                    tsrc:cvsUtility.queryMap.source // dynamic value email/sms for guest user and do't populate if register user
                },
                "guestAddEditBank": {
                    page_name: 'add/edit bank account',
                    page_category: 'Payment',
                    scenario_name: 'unreg: OLP',
                    scenario_step: 'Account 1-Time',
                    tsrc:cvsUtility.queryMap.source// dynamic value email/sms for guest user and do't populate if register user
                },
                "guestAddEditCreditCard": {
                    page_name: 'add/edit credit card',
                    page_category: 'Payment',
                    scenario_name: 'unreg: OLP',
                    scenario_step: 'Card 1-Time',
                    tsrc:cvsUtility.queryMap.source// dynamic value email/sms for guest user and do't populate if register user
                },

                /* guestReviewPayment will not fire to keep page_name consistent for logged-in and guest flow. */
                // "guestReviewPayment": {           
                //     page_name: 'review payment',
                //     page_category: 'Payment',
                //     scenario_name: 'unreg: OLP',
                //     scenario_step: 'payment review 1-time',
                //     tsrc:cvsUtility.queryMap.source // dynamic value email/sms for guest user and do't populate if register user
                // },

                /* guestPaymentSubmitted will not fire to keep page_name consistent for logged-in and guest flow. */
                // "guestPaymentSubmitted": {
                //     page_name: 'srx: payment confirmation',
                //     page_category: 'Payment',
                //     scenario_name: 'unreg: OLP',
                //     scenario_step: 'pay success 1-time',
                //     tsrc:cvsUtility.queryMap.source // dynamic value email/sms for guest user and do't populate if register user
                // },
                "guestPaymentSubmittedRefillNow": {
                    page_name: 'link: unreg pay success: refill now',
                    page_category: 'Refill',
                    tsrc:cvsUtility.queryMap.source // dynamic value email/sms for guest user and do't populate if register user
                },
                "guestPaymentSubmittedRegisterAndRefill": {
                    page_name: 'link: unreg pay success: reg & refill',
                    page_category: 'quick reg',
                    tsrc:cvsUtility.queryMap.source // dynamic value email/sms for guest user and do't populate if register user
                }

            };

            return webAnalyticsData;
        };

        return new webAnalyticsData();
    });
